var TagComponent = new JS.Class(EditorComponent, {
  initialize: function(selector, allowNew) {
    this.element = $(selector);
    var that = this;
    var options = {
      width: 'resolve',
      minimumInputLength: 2,
      multiple: true,
      initSelection: function($element, callback) {
        callback(
          $.map($element.val().split(/[,\s]/), function(value, index) {
            return value
              ? {
                  id: value,
                  text: value,
                }
              : null;
          })
        );
      },
      ajax: {
        url: '/json/search/lookup/suggestTag/',
        dataType: 'json',
        data: function(term, page) {
          return {
            types: 'tag',
            query: term,
          };
        },
        results: function(data, page) {
          data = data.result.results;
          return {
            more: false,
            results: $.map(data, function(value, index) {
              var title = Utilities.escape(value.title);
              return {
                id: title,
                text: title,
              };
            }),
          };
        },
      },
      tags: [],
    };

    if (allowNew) {
      options.createSearchChoice = function(term) {
        return { id: term.toLowerCase(), text: term };
      };
      options.tokenSeparators = [',', ' '];
    }

    that.element.select2(options);
  },

  getSaveData: function() {
    return {
      tags: $.map(this.element.val().split(/[,\s]/), function(value, index) {
        return value ? value : null;
      }),
    };
  },
});
